<template>
  <gg-card>
    <gg-card-header>
      <span>AutoSSL Problems</span>
      <gg-btn @click="loadProblemsList"
              :loading="loading"
              aria-label="Refresh Auto SSL Problems list."
              class="ml-2">
        <v-icon>mdi-refresh</v-icon>
      </gg-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="primary" class="ml-2" small v-on="on">
            mdi-help-circle
          </v-icon>
        </template>
        <span>Review certificates that had problems getting issued.</span>
      </v-tooltip>
    </gg-card-header>
    <gg-card-text>
      <v-data-table :headers="headers"
                    :loading="loading"
                    :items="autoSslProblems">
        <template #item.problem="{ item }">
          <div class="problem">
            {{ item.problem }}
          </div>
        </template>
        <template #item.time="{ item }">
          {{ formatDate(item.time) }}
        </template>
      </v-data-table>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { format } from 'date-fns'

export default {
  name: 'AutoSslProblems',
  data () {
    return {
      headers: [
        {
          text: 'Domain',
          value: 'domain'
        },
        {
          text: 'Problem',
          sortable: false,
          value: 'problem'
        },
        {
          text: 'Date',
          value: 'time'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      hosting: 'hosting',
      autoSslServiceId: 'auto_ssl_manager/autoSslServiceId',
      autoSslProblems: 'auto_ssl_manager/autoSslProblems',
      loading: 'auto_ssl_manager/loadingAutoSslProblems'
    })
  },
  methods: {
    ...mapActions({
      getAutoSslProblems: 'auto_ssl_manager/getAutoSslProblems',
      reportError: 'reportError'
    }),
    formatDate (dateStr) {
      return format(new Date(dateStr), 'yyyy-MM-dd HH:mm')
    },
    async loadProblemsList () {
      try {
        await this.getAutoSslProblems({ serviceId: this.hosting.id, username: this.$route.query.user })
      } catch (e) {
        this.reportError(e)
      }
    }
  },
  mounted () {
    if (this.autoSslServiceId == this.hosting.id && this.autoSslProblems.length > 0) {
      return
    }
    this.loadProblemsList()
  }
}
</script>

<style scoped>
.problem {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
}
</style>
